module.exports = __webpack_public_path__ + "static/img/swiper-5.ecaa8cf0.png";